import { nextTick } from 'vue';

/**
 * 在 input/textarea 目前選取範圍插入文字，並透過 callback 同步 v-model。
 * @param {HTMLInputElement|HTMLTextAreaElement|null} el
 * @param {string} insertion
 * @param {(nextFullValue: string) => void} applyModel
 * @returns {Promise<boolean>}
 */
export async function insertTextAtCaret(el, insertion, applyModel) {
  if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) {
    return false;
  }
  if (typeof applyModel !== 'function') {
    return false;
  }

  const start = Number.isFinite(el.selectionStart) ? el.selectionStart : 0;
  const end = Number.isFinite(el.selectionEnd) ? el.selectionEnd : start;
  const val = el.value ?? '';
  const next = val.slice(0, start) + insertion + val.slice(end);
  applyModel(next);

  await nextTick();
  el.focus();
  const pos = start + insertion.length;
  try {
    el.setSelectionRange(pos, pos);
  } catch {
    // 少數 input type 不支援
  }
  return true;
}
